module.exports = __webpack_public_path__ + "assets/img/18_923_big.fafa669a.jpg";